
export default {
  vessel: {
    title: {
      fontWeight: 'bold',
      color: 'black',
      fontSize: {
        all: 'xl',
        sm: '2xl'
      }
    },
    subtitle: {
      $extend: 'title',
      fontWeight: 'light',
      color: 'grey-darker',
      fontSize: {
        all: 'lg',
        sm: 'xl'
      }
    }
  }
}
